import React, { useState } from 'react';
import { countLabel, RecordToolbar } from 'components/record-shell/RecordList';
import { Grid } from '@mui/material';

import ConfirmDialog from 'components/confirm-dialog/ConfirmDialog';
import ProcedurePackagesList from './list/ProcedurePackagesList';
import ProcedurePackageForm from './form/ProcedurePackageForm';
import { Procedure, ProcedurePackage } from 'types/procedure';

interface ProcedurePackagesProps {
  procedure: Procedure;
  handleChangeAddPackage(pkg: ProcedurePackage): void;
  handleDeletePackage(pkg: ProcedurePackage): void;
}

const ProcedurePackages: React.FC<ProcedurePackagesProps> = ({
  procedure,
  handleDeletePackage,
  handleChangeAddPackage,
}) => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<ProcedurePackage | null>(null);
  const [packageInfo, setPackageInfo] = useState<ProcedurePackage>({
    priority: 1,
    package: null,
    id: 0,
    package_id: 0,
  });

  function handleChangePackageInfo<K extends keyof ProcedurePackage>(index: K, value: ProcedurePackage[K]) {
    setPackageInfo(prev => ({ ...prev, [index]: value }));
  }

  function handleAddPackage(packageInfo: ProcedurePackage | null) {
    if (!packageInfo) return;
    handleChangeAddPackage(packageInfo);
    setAddDialogOpen(false);
    setPackageInfo({
      priority: 1,
      package_id: 0,
      id: 0,
      package: null,
    });
  }

  function onExited() {
    setAddDialogOpen(false);
    setPackageInfo({
      id: 0,
      priority: 1,
      package: null,
      package_id: 0,
    });
    setEditDialogOpen(false);
  }

  function handleEditPackage(procedure: ProcedurePackage, index: number) {
    setEditDialogOpen(true);
    setPackageInfo(procedure);
  }

  return (
    <Grid container size={12} spacing={2}>
      {confirmDialogOpen && (
        <ConfirmDialog
          confirmLabel="Excluir"
          destructive
          handleNoClick={() => setConfirmDialogOpen(null)}
          handleYesClick={() => {
            handleDeletePackage(confirmDialogOpen);
            setConfirmDialogOpen(null);
          }}
          title="Tem certeza que deseja excluir este pacote?"
        />
      )}
      <Grid size={12}>
        <RecordToolbar
          title={countLabel(
            procedure.packages.length,
            'pacote cadastrado',
            'pacotes cadastrados',
            'Nenhum pacote cadastrado',
          )}
          addLabel="Adicionar pacote"
          onAdd={() => setAddDialogOpen(true)}
        />
      </Grid>

      {procedure.packages.length > 0 && (
        <ProcedurePackagesList
          packages={procedure.packages}
          handleDeletePackage={pkg => setConfirmDialogOpen(pkg)}
          handleEditPackage={handleEditPackage}
        />
      )}

      {addDialogOpen && (
        <ProcedurePackageForm
          type="new"
          handleChangePackageInfo={handleChangePackageInfo}
          packageInfo={packageInfo}
          handleAddPackage={handleAddPackage}
          onExited={onExited}
        />
      )}

      {!!packageInfo.id && editDialogOpen && (
        <ProcedurePackageForm
          type="edit"
          handleChangePackageInfo={handleChangePackageInfo}
          packageInfo={packageInfo}
          handleAddPackage={handleAddPackage}
          onExited={onExited}
        />
      )}
    </Grid>
  );
};

export default ProcedurePackages;
